var _a;
import { createActions } from 'redux-actions';
export var getInspirations = (_a = createActions('GET_INSPIRATIONS', 'GET_INSPIRATIONS_COMPLETE'), _a.getInspirations), getInspirationsComplete = _a.getInspirationsComplete;
